import {ContentContainer} from '@coolcolduk/ui-mui';
import {useNavigate} from 'react-router';
import {PrivateRouteProps} from '../../config/routeType';
import useListUserProgress from '../../hooks/userProgress/useListUserProgress';
import useUserCompletedSessions from '../../hooks/quizSession/useUserCompletedSessions';
import ExerciseActivity from './ExerciseActivity';
import ExerciseNoModule from './ExerciseNoModule';
import ExerciseSession from './ExerciseSession';
import ExerciseStats from './ExerciseStats';
import ExerciseTitle from './ExerciseTitle';

export default function ExercisePage({user}: PrivateRouteProps) {
  const navigate = useNavigate();
  const {progressList, loading: progressLoading} = useListUserProgress();
  const {sessions, loading: sessionsLoading} = useUserCompletedSessions({limit: 50});

  const handleStartSession = () => {
    navigate('/session/new');
  };

  // Check if user has no selected modules
  const hasModules = user.selectedModules && user.selectedModules.length > 0;

  // Calculate overall accuracy from progress data
  const calculateOverallAccuracy = () => {
    if (!progressList || progressList.length === 0) {
      return 0;
    }

    const totalCorrect = progressList.reduce((sum, progress) => sum + progress.totalCorrect, 0);
    const totalAnswered = progressList.reduce((sum, progress) => sum + progress.totalAnswered, 0);

    if (totalAnswered === 0) {
      return 0;
    }

    return Math.round((totalCorrect / totalAnswered) * 100);
  };

  const overallAccuracy = calculateOverallAccuracy();

  return (
    <ContentContainer data-testid="exercise-page">
      <ExerciseTitle user={user} />

      {hasModules ? <ExerciseSession onStartSession={handleStartSession} /> : <ExerciseNoModule />}

      <ExerciseStats
        overallAccuracy={overallAccuracy}
        sessions={sessions}
        user={user}
        loading={progressLoading || sessionsLoading}
      />

      <ExerciseActivity />
    </ContentContainer>
  );
}
